import { pagifyCdnJS } from "../constants/env";
import { PAGIFY_FAILURE_FALLBACK_STRING } from "../receiptOnClient/GeneratePDFOnClient";
import { track } from "./tracking";

let pagifyLoaded = false;
let loadingPromise: Promise<void> | null = null;

export const ensurePagifyLoaded = async (): Promise<void> => {
  if (pagifyLoaded && (window as any).pagify) return;

  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = script.src = pagifyCdnJS;
    // script.src = "http://localhost:8081/dist/pagify.standalone.js";

    script.onload = () => {
      pagifyLoaded = true;
      resolve();
    };
    script.onerror = () => {
      loadingPromise = null;
      track("FAILED_TO_LOAD_PAGIFY_ELIXIR");
      reject(new Error(PAGIFY_FAILURE_FALLBACK_STRING));
    };
    document.head.appendChild(script);
  });

  return loadingPromise;
};
